import React, { useState, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { ChannelRepository } from '@amityco/js-sdk';
import GroupSettings from '../../../../chat/components/GroupSettings';
import { ControlItem, ControlItemLabel, SideWrapper, GroupSettingIcon } from './styles';
const MenuGroupSetting = ({ chatName, channelId }) => {
    const [shouldShowSettingsModal, setShouldShowSettingsModal] = useState(false);
    const updateGroupName = (newGroupChatName) => {
        ChannelRepository.setDisplayName({ channelId, displayName: newGroupChatName });
    };
    return (React.createElement(Fragment, null,
        React.createElement(ControlItem, { onClick: () => setShouldShowSettingsModal(true) },
            React.createElement(SideWrapper, null,
                React.createElement(GroupSettingIcon, null),
                React.createElement(ControlItemLabel, null,
                    React.createElement(FormattedMessage, { id: "chat.groupSetting" })))),
        shouldShowSettingsModal && (React.createElement(GroupSettings, { title: React.createElement(FormattedMessage, { id: "chat.groupSetting" }), chatName: chatName, submitButtonName: React.createElement(FormattedMessage, { id: "general.done.capital" }), closeModal: () => setShouldShowSettingsModal(false), onSubmit: updateGroupName }))));
};
export default MenuGroupSetting;
//# sourceMappingURL=MenuGroupSetting.js.map